import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  isLoading?: boolean;
  children?: JSX.Element | string;
}

export const DealsTableSkeleton: React.FC<Props> = (props: Props) => {
  const { isLoading, children } = props;

  const attrs = {
    wrapper: { className: 'deals-table-skeleton' },
    row: {
      wrapper: { className: 'deals-table-skeleton__row' },
      elements: {
        leftSection: {
          wrapper: {
            className: 'deals-table-skeleton__row__left-section',
          },
          first: {
            className: 'deals-table-skeleton__row__left-section-first',
          },
          second: {
            className: 'deals-table-skeleton__row__left-section-second',
          },
          third: {
            className: 'deals-table-skeleton__row__left-section-third',
          },
        },
        centralSection: {
          wrapper: {
            className: 'deals-table-skeleton__row__central-section',
          },
          fourth: {
            className: 'deals-table-skeleton__row__central-section-fourth',
          },
          fifth: {
            className: 'deals-table-skeleton__row__central-section-fifth',
          },
        },
        rightSection: {
          wrapper: {
            className: 'deals-table-skeleton__row__right-section',
          },
          sixth: {
            className: 'deals-table-skeleton__row__right-section-sixth',
          },
          seventh: {
            className: 'deals-table-skeleton__row__right-section-seventh',
          },
          eighth: {
            className: 'deals-table-skeleton__row__right-section-eighth',
          },
        },
      },
    },

    skeleton: {
      loading: isLoading,
      active: true,
      avatar: false,
      paragraph: false,
      title: {
        style: {
          width: '100%',
          height: 10,
          borderRadius: 2,
          margin: 'auto',
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
  };

  const checkboxSkeleton = (
    <Skeleton
      loading={isLoading}
      active
      avatar={false}
      paragraph={false}
      title={{
        style: {
          width: '100%',
          height: 16,
          borderRadius: 2,
          marginTop: 0,
        },
      }}
    />
  );

  const row = (
    <div {...attrs.row.wrapper}>
      <div {...attrs.row.elements.leftSection.wrapper}>
        <div {...attrs.row.elements.leftSection.first}>{checkboxSkeleton}</div>
        <div {...attrs.row.elements.leftSection.second}>
          <Skeleton {...attrs.skeleton} />
        </div>
        <div {...attrs.row.elements.leftSection.third}>
          <Skeleton {...attrs.skeleton} />
        </div>
      </div>
      <div {...attrs.row.elements.centralSection.wrapper}>
        <div {...attrs.row.elements.centralSection.fourth}>
          <Skeleton {...attrs.skeleton} />
        </div>
        <div {...attrs.row.elements.centralSection.fifth}>
          <Skeleton {...attrs.skeleton} />
        </div>
      </div>
      <div {...attrs.row.elements.rightSection.wrapper}>
        <div {...attrs.row.elements.rightSection.sixth}>
          <Skeleton {...attrs.skeleton} />
        </div>
        <div {...attrs.row.elements.rightSection.seventh}>
          <Skeleton {...attrs.skeleton} />
        </div>
        <div {...attrs.row.elements.rightSection.eighth}>
          <Skeleton {...attrs.skeleton} />
        </div>
      </div>
    </div>
  );

  const hdOrLessResolutionBody = (
    <div {...attrs.wrapper}>
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
    </div>
  );

  const hdplusAndMoreResolutionBody = (
    <div {...attrs.wrapper}>
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
    </div>
  );

  const resolutionDepBody =
    window.innerWidth <= 1366
      ? hdOrLessResolutionBody
      : hdplusAndMoreResolutionBody;

  return <>{isLoading ? resolutionDepBody : children}</>;
};
